import { Component, Input } from '@angular/core';
import { CurrencyAmountDto } from '@hub/generated/models';

@Component({
	selector: 'g-columnCurrencyAmount',
	templateUrl: './columnCurrencyAmount.component.html'
})
export class ColumnCurrencyAmountComponent {
	@Input() data: CurrencyAmountDto;
	@Input() isEditing: boolean = false;
}
